/**
 * A factory function that retrieves the CSRF token.
 * Returns the token (or null), a function that reloads the token, and lastly
 * the HTTP header key and value (that can be merged to the request header
 * object).
 *
 * @returns {{
 *   token: ?string;
 *   reload: Function;
 *   header: { X-CSRF-Token: ?string }
 *  }}
 */
export default function csrfToken() {
  let token;

  const loadToken = function () {
    const metaElement = document.head.querySelector('meta[name="csrf-token"]');

    token = metaElement && metaElement.getAttribute('content');
  };

  loadToken();

  return {
    token,
    reload: () => loadToken(),
    header: token ? { 'X-CSRF-Token': token } : {},
  };
}
